import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'boxx-phone-type-picker',
  templateUrl: './phone-type-picker.component.html',
  styleUrls: ['./phone-type-picker.component.scss'],
})
export class PhoneTypePickerComponent implements OnInit, OnDestroy {
  types = [
    { key: 'LOCAL', value: '', class: 'local' },
    { key: 'MOBILE', value: '', class: 'mobile' }
  ];
  destroyed$ = new Subject<boolean>();
  constructor(
    private modalCtrl: ModalController,
    private translate: TranslateService
  ) {
    this.translate
      .get(['ONBOARDING_MODULE'])
      .pipe(takeUntil(this.destroyed$))
      .subscribe((t: any) => {
        this.types[0].value = t.ONBOARDING_MODULE.BUSINESS_DATA.BUSINESS_PHONE_TYPES.local;
        this.types[1].value = t.ONBOARDING_MODULE.BUSINESS_DATA.BUSINESS_PHONE_TYPES.mobile;
      });
  }

  ngOnInit() {
  }

  ngOnDestroy() {
  }

  selectTypePhone(type){
    const typeSelected = type;
    this.modalCtrl.dismiss({data: typeSelected} );
  }

  async close() {
    this.modalCtrl.dismiss();
  }

}
